import React from 'react'
import { X } from 'lucide-react'

export default function Modal({ title, children, closeModal }) {

    return (
        <>
            <div className="modal-wrapper"></div>
            <div className={`bg-white rounded-md modal-card border`} >
                <div className="bg-gray-50 h-10 px-4 flex justify-between items-center border-b-2">
                    <h1 className="text-xl font-semibold">{title}</h1>
                    <button type="button" className="hover:bg-gray-200" onClick={closeModal}><X /></button>
                </div>

                <div className="card-body px-4 py-2">
                    {children}
                </div>
            </div>
        </>
    )
}
